import axios from '../../axios';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';
import { OverdueInvoice } from '../../../models/response/overdueInvoice';

export default async function getOverdueInvoicesRepository(): Promise<
  OverdueInvoice[]
> {
  const res = await axios.get<OverdueInvoice[]>(
    `${process.env.REACT_APP_BASE_URL}/overdue-invoice`
  );
  return res.data;
}
